import React from "react"
import BlockHero from "@components/common/blockHero"
import BlockModalBtn from "@components/common/blockModalBtn"
import BlockColumns from "@components/common/blockColumns"
import ChangePageBtn from "@components/common/changePageBtn"
import { languageUtils } from "@utils/language"

import Finalizacion from "@images/hitos/finalizacion.jpg"
import Respuesta from "@images/hitos/respuesta.jpg"
import Rsc from "@images/hitos/rscBtn.jpg"

const Index = () => {
  const currentPath = '/cat/fites-i-estrategia/' // languageUtils.getCurrentPath()

  return (
    <section>
      <div className="element">
        <BlockHero
          title="FITES I ESTRATÈGIA"
          description="La pandèmia de la COVID-19 ha marcat l’acompliment de Mutua Universal el 2020.
          L’Entitat ha prioritzat en tot moment la continuïtat del servei en tots els seus àmbits d’actuació, contribuint d’aquesta manera a frenar el contagi. En paral·lel, ha desenvolupat els seus eixos estratègics i ha culminat amb èxit el Pla Estratègic 2018-2020."
        />
      </div>
      <div className="element">
        <BlockModalBtn
          image={Respuesta}
          to={`${currentPath}resposta-efectiva-a-la-crisis-sanitaria`}
        >
          <span>Resposta efectiva a la crisi sanitària</span>
        </BlockModalBtn>
      </div>
      <div className="element-flex">
        <BlockModalBtn image={Finalizacion} to={`${currentPath}finalitzacio-del-pla-estrategic-2018-2020`}>
          <span>Finalització del Pla Estratègic 2018-2020</span>
        </BlockModalBtn>
        <BlockModalBtn image={Rsc} to={`${currentPath}rsc-4.0-treballem-pel-nostre-proposit`}>
          <span>RSC 4.0: Treballem pel nostre propòsit</span>
        </BlockModalBtn>
      </div>
      <div className="element">
        <BlockColumns
          title="El Pla Estratègic 2018-2020 i el Pla Director RSC 2018-2020 responen al propòsit, la missió, la visió i els valors de l’Entitat."
          proposito={{
            title: "Propòsit",
            description:
              "Ser socialment responsables i contribuir a la sostenibilitat de l’estat del benestar.",
          }}
          mision={{
            title: "Missió",
            description:
              "Vetllar per a la salut i el benestar dels nostres mutualistes, gestionant els serveis i les prestacions amb rigor i excel·lència, compromesos amb la societat i la sostenibilitat del sistema.",
          }}
          vision={{
            title: "Visión",
            description:
              "Ser excel·lents basant-nos en les nostres persones, la innovació i l’orientació als mutualistes.",
          }}
          valores={{
            title: "Valors",
            description: [
              "Qualitat",
              "Professionalitat",
              "Eficiència",
              "Integritat",
            ],
          }}
        />
      </div>
      <div className="element changePage">
        <ChangePageBtn />
      </div>
    </section>
  )
}

export default Index
